import type { SVGProps } from 'react';
export const IconSocialsYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.627 12.35c.402.409.688.915.829 1.468.375 2.047.557 4.125.543 6.205a33.28 33.28 0 0 1-.543 6.113 3.224 3.224 0 0 1-.83 1.468 3.294 3.294 0 0 1-1.463.86C28.131 29 20 29 20 29s-8.13 0-10.163-.536a3.297 3.297 0 0 1-1.444-.821 3.227 3.227 0 0 1-.849-1.414 33.28 33.28 0 0 1-.543-6.206c-.01-2.065.171-4.127.543-6.159.14-.552.427-1.059.83-1.468a3.294 3.294 0 0 1 1.463-.86C11.87 11 20 11 20 11s8.13 0 10.163.489a3.295 3.295 0 0 1 1.464.86Zm-7.824 6.754-5.126-3.247c-.521-.33-.782-.496-.998-.48a.652.652 0 0 0-.474.255c-.13.17-.13.476-.13 1.087v6.493c0 .611 0 .917.13 1.087a.653.653 0 0 0 .474.256c.216.015.477-.15.998-.481l5.126-3.247c.453-.286.68-.43.758-.612a.631.631 0 0 0 0-.499c-.079-.182-.305-.326-.758-.612Z"
      fill="currentColor"
    />
  </svg>
);
